/**
 * Meui Meter — the studio's internal view counter, used to measure hosting cost.
 *
 * The marketing site and every Payload site load `m.js` from a `<script>` in their
 * server-rendered HTML. This SPA has no server render: `index.html` is a static file
 * built once, so the tag is injected here instead, from the same `dist/` that serves
 * web, mobile web and the Capacitor wrap.
 *
 * `__METER_KEY__` is replaced at build time by `vite.config.ts` with the half of
 * METER_KEY before the first dot — the secret half never enters the bundle.
 */
import { isNative } from '@bitez/data'

declare const __METER_KEY__: string

const METER_SRC = 'https://studio.meui.cz/m.js'

/**
 * Loads the meter, unless there is nothing to measure.
 *
 * Skipped on native (techsheet rule 6: platform differences are runtime branches).
 * A Capacitor webview is served from the app bundle on the device, not from our
 * server, so those views cost us no hosting and must not be counted. `m.js` would
 * bail on its own — Capacitor's origin is `localhost`, which its dev guard catches —
 * but relying on that coincidence would leave the intent unwritten.
 */
export function initMeter(): void {
  if (!__METER_KEY__ || isNative()) return

  const script = document.createElement('script')
  script.defer = true
  script.src = METER_SRC
  script.dataset.key = __METER_KEY__
  document.head.appendChild(script)
}
